import React, { useContext } from "react";
import { Context } from "../AppContext";
import { navigate } from "gatsby";

export default function useAuth() {
  const app = useContext(Context);

  const isBrowser = typeof window !== "undefined";

  let token;
  if (isBrowser) {
    token = window.localStorage.getItem("token");
  }

  const isLogin = () => !!token;

  const handleUnauthenticated = () => {
    if (!isLogin()) {
      navigate("/");
    }
  };

  const handleUnauthenticatedWithLoginModal = (page = "/orders") => {
    console.log("handleUnauthenticatedWithLoginModal: ");

    if (isLogin()) {
      navigate(page);
    } else {
      app.actions.setLoginModal(true);
    }
  };

  return {
    isLogin,
    handleUnauthenticated,
    handleUnauthenticatedWithLoginModal,
  };
}
